import { notification } from './Notification.style';
import { TOneBoxV2GetNotificationMessageDetail } from '~/api/oneBoxV2/oneBoxV2.type';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { CampaignRounded } from '@mui/icons-material';

const FIXED_HOMEPAGE_NOTICE =
  '歡迎老師使用 NaniBox！請先登入並選擇學制、年級和科目，以瀏覽所需資源。';

type TProps = {
  notificationList: TOneBoxV2GetNotificationMessageDetail[];
};

export const Notification = ({ notificationList }: TProps) => {
  return (
    <notification.Container>
      <CampaignRounded
        sx={{ fill: 'secondary.darker', fontSize: '24px', color: '#576FC3' }}
      />
      {notificationList.length === 0 ? (
        <notification.Text
          variant="body2"
          sx={{ width: '100%', height: '100%' }}
        >
          {FIXED_HOMEPAGE_NOTICE}
        </notification.Text>
      ) : (
        <Swiper
          direction={'vertical'}
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          style={{ width: '100%', height: '100%' }}
        >
          {notificationList.map(item => (
            <SwiperSlide
              key={item.id}
              data-swiper-autoplay={`${item.seconds}000`}
            >
              <notification.Text
                variant="body2"
                sx={{ width: '100%', height: '100%' }}
              >
                {item.content}
              </notification.Text>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </notification.Container>
  );
};
